import { z } from 'zod';

const serviceNotificationSchema = z.object({
  reservationStatus: z.object({
    Pending: z.boolean().optional(),
    Accepted: z.boolean().optional(),
    Completed: z.boolean().optional(),
    Absent: z.boolean().optional(),
    Requested: z.boolean().optional(),
    Proposed: z.boolean().optional(),
    Rejected: z.boolean().optional(),
    Cancelled: z.boolean().optional()
  }).optional()
});

export default serviceNotificationSchema;
